// Local theme definitions migrated from @glueapp/component-library
// This allows us to remove the dependency on the component library

export interface GlueColorsType {
    separatorColor: string;
    textColor: string;
    disabledText: string;
    primaryColor: string;
    backgroundColor: string;
    elevatedBackgroundColor: string;
    subtleAccentColor: string;
    positiveAccentColor: string;
    negativeAccentColor: string;
    errorColor: string;
    primaryContrastColor: string;
    subtleContrastColor: string;
    deleteRed: string;
}

export interface GlueSpacesType {
    [key: number]: string;
}

export interface ThemeType extends GlueColorsType {
    colors: GlueColorsType;
    space: GlueSpacesType;
}

const darkThemeColors: GlueColorsType = {
    separatorColor: 'black',
    textColor: 'white',
    disabledText: '#6d6d6d',
    primaryColor: 'black',
    backgroundColor: '#222222',
    elevatedBackgroundColor: '#323232',
    subtleAccentColor: '#555',
    positiveAccentColor: '#237dea',
    negativeAccentColor: '#d94d65',
    errorColor: '#CC0000',
    primaryContrastColor: 'white',
    subtleContrastColor: '#dddddd',
    deleteRed: '#ff0436',
};

const lightThemeColors: GlueColorsType = {
    separatorColor: '#dadbdf',
    textColor: '#363636',
    disabledText: '#afafb0',
    primaryColor: 'white',
    backgroundColor: '#F0F1f5',
    elevatedBackgroundColor: '#E6E7EB',
    subtleAccentColor: '#d7d9e0',
    positiveAccentColor: '#237dea',
    negativeAccentColor: '#d94d65',
    errorColor: '#CC0000',
    primaryContrastColor: '#3a3d42',
    subtleContrastColor: '#5b6064',
    deleteRed: '#f12019',
};

const glueSpaces: GlueSpacesType = {
    0: '0rem',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
};

export const DarkTheme: ThemeType = {
    ...darkThemeColors,
    colors: darkThemeColors,
    space: glueSpaces,
};

export const LightTheme: ThemeType = {
    ...lightThemeColors,
    colors: lightThemeColors,
    space: glueSpaces,
};
